export class Credentials {
  constructor (params) {
    const { userId } = params
    this.userId = userId || null
  }
}
